<template>
  <q-avatar
    class="item non-selectable"
    text-color="white"
    size="4.5rem"
    font-size="2rem"
    :color="avatarColor"
  >
    <img v-if="logo" :src="logo" :alt="altName" />
    <span v-else-if="name">{{ getInitials(name) }}</span>
    <span v-else>?</span>

    <q-tooltip anchor="top middle" self="bottom middle" content-class="text-capitalize">
      {{ type }}
    </q-tooltip>
  </q-avatar>
</template>

<script>
export default {
  props: {
    /** Company logo */
    logo: {
      type: String,
      required: false,
    },
    /** Company name or trading name */
    name: {
      type: String,
      required: false,
    },
    /** Type determines tooltip display value, can only be `shipper` or `transporter` */
    type: {
      type: String,
      default: 'transporter',
      validator(value) {
        return ['shipper', 'transporter'].includes(value);
      },
    },
    isShipperPictureEmpty: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    avatarColor() {
      if (this.logo) return '';

      /**
       * If transporter does not have profile picture and neither does shipper,
       * transporter will use a lighter background image.
       * Otherwise use primary color.
       *
       * If shipper does not have profile picture, use primary background color.
       */
      return this.type === 'transporter' && this.isShipperPictureEmpty === true
        ? 'light-blue-3'
        : 'primary';
    },
    altName() {
      return `${this.name}'s profile photo`;
    },
  },

  methods: {
    /**
     * Only get the first 2 initials
     *
     * @param {string} name
     */
    getInitials(name) {
      const [first, second] = name.split(' ');
      let initial = '';

      if (first) {
        initial += first[0];
      }
      if (second) {
        initial += second[0];
      }

      return initial.toUpperCase();
    },
  },
};
</script>

<style scoped>
.item:not(:first-child) {
  margin-left: -1rem;
}

.item >>> .q-avatar__content {
  border: 3px solid white;
}
</style>
